import React from 'react';

interface ShortcutDisplayProps {
  keys: string | string[]; // Shortcut string, e.g., "ctrl+shift+s"
}

const modifierIcons: Record<string, string> = {
  ctrl: '⌃', // Control
  shift: '⇧', // Shift
  alt: '⌥', // Option/Alt
  meta: '⌘', // Command (Mac)
  command: '⌘' // Alias for meta
};

const getDisplayKey = (key: string): string => {
  const lowerKey = key.toLowerCase();
  return modifierIcons[lowerKey] || key.toUpperCase(); // Use icon if it's a modifier, else return the key
};

export const ShortcutDisplay: React.FC<ShortcutDisplayProps> = ({ keys }) => {
  const keyArray = String(Array.isArray(keys) ? keys[0] : keys).split('+');

  return (
    <div
      className={'rounded bg-background-primary/20 px-2'}
      style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
    >
      {keyArray.map((key, index) => (
        <div
          key={index}
          style={{
            display: 'inline-flex',
            fontSize: '0.9em',
            textTransform: 'capitalize'
          }}
        >
          {getDisplayKey(key)}
        </div>
      ))}
    </div>
  );
};
